
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


console.error = (e) => {
    console.warn(e);
}


const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
    <App />
);